var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
import * as React from 'react';
import cls from 'classnames';
import { tools } from 'rcm-mobile';
import './style/index.scss';
/**
 * @author tongxiaokang
 * @version 0.0.1
 */
export default class Icon extends React.PureComponent {
    constructor(props) {
        super(props);
        this.refIcon = React.createRef();
        this.initIconTransform = () => {
            const { rotate } = this.state;
            if (rotate) {
                tools.helper.setTransform(this.refIcon.current, `rotate(${rotate}deg)`);
            }
        };
        this.state = {
            spin: props.spin,
            rotate: props.rotate
        };
    }
    render() {
        const _a = this.props, { style, spin, className, children } = _a, restProps = __rest(_a, ["style", "spin", "className", "children"]);
        return (<i style={style} ref={this.refIcon} className={cls('x-icon', className, { 'x-amt-spin': spin })} {...restProps}>
        {children}
      </i>);
    }
    componentDidMount() {
        this.initIconTransform();
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.rotate !== prevState.rotate || nextProps.spin !== prevState.spin) {
            return nextProps;
        }
        return null;
    }
    componentDidUpdate(prevProps) {
        if (prevProps.rotate !== this.props.rotate) {
            this.initIconTransform();
        }
    }
    static getRotate(arrow) {
        let rotate = 0;
        // 初始化箭头方向
        switch (arrow) {
            case 'left':
                rotate = 0;
                break;
            case 'top':
                rotate = 90;
                break;
            case 'bottom':
                rotate = 270;
                break;
            default:
                rotate = 180;
        }
        return rotate;
    }
}
Icon.defaultProps = {
    style: {},
    spin: false,
    rotate: 0
};
